<template>
    <v-img
        position="center" eager cover dark class="img-welcome"
        :src="require('@/assets/img/welcome.png')"
        gradient="rgba(0,0,0,.30), rgba(0,0,0,.30)"
    >
        <v-row class="row-welcome">
            <v-col cols="12">
                <div class="welcome-title">
                    {{ $t('entrance.welcome_title') }}
                </div>
                <div class="welcome-subtitle">
                    {{ subtextMessage }}
                </div>
            </v-col>
            <v-col cols="12">
                <v-btn
                    v-if="!showRetryBtn"
                    color="primary" class="black--text normal-btn"
                    large @click="continueToHome" :loading="loading">
                    {{ $t('common.continue') }}
                </v-btn>
                <v-btn
                    v-else
                    color="primary" class="black--text normal-btn"
                    large @click="onRetry" :loading="loading">
                    {{ $t('common.retry') }}
                </v-btn>
            </v-col>
        </v-row>
    </v-img>
</template>

<script>

export default {
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        showRetryBtn: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        subtextMessage(vm = this) {
            switch (vm.account?.accountType) {
                case 'coach':
                    return vm.$t('entrance.welcome_subtitle_coach')
                case 'student':
                    return vm.$t('entrance.welcome_subtitle')
                case 'company':
                    return vm.$t('company.welcome_subtitle')
                default:
                    return ''
            }
        }
    },
    methods: {
        continueToHome() {
            const vm = this
            vm.$emit('continue')
        },
        onRetry() {
            const vm = this
            vm.$emit('retry')
        },
    },
}
</script>

<style scoped>

.welcome-title {
    font-size: 35px;
    font-weight: bold;
    line-height: 35px;
}

.welcome-subtitle {
    font-size: 20px;
    margin-top: 24px;
    line-height: 24px;
}

.row-welcome {
    position: absolute;
    left: 10%;
    right: 10%;
    bottom: 10%;
}

.img-welcome {
    background-size: cover;
    background-position: center;
    height: calc(100vh - 50px);
}

</style>